import { useEffect } from 'react'
import { useSearchStore } from 'src/store/search'
import { Pagination, Card, Col, Button, Row, Spin, Tag } from 'antd'
import { PhotoProvider, PhotoView } from 'react-photo-view'
import { Preloader } from 'src/components/preloader'
import { useAuthStore } from 'src/store/auth'
import 'react-photo-view/dist/react-photo-view.css'
import { Link } from 'react-router-dom'

export const Photos = () => {
  const { searchData, isLoading, onSearch, searchPagination } = useSearchStore(
    (store) => store
  )

  const { setActiveKeyMainMenu } = useAuthStore((store) => store)

  useEffect(() => {
    onSearch(1)
    setActiveKeyMainMenu('mainMenu3')
  }, [])

  return (
    <div>
      <h1>Photos</h1>
      <div style={{ position: 'relative', padding: '20px 0' }}>
        {isLoading ? <Preloader /> : null}
        {searchData
          ? searchData.map((photo) => (
              <Card key={photo?.id} style={{ margin: '10px 0' }}>
                <Row>
                  <Col
                    xs={24}
                    md={6}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <div>
                      <p style={{ paddingBottom: 5 }}>
                        ID: <Tag color='red'>{photo?.id || '-'}</Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Created at:{' '}
                        <Tag color='green'>
                          {photo?.readable_created_at || '-'}
                        </Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Updated at:{' '}
                        <Tag color='cyan'>
                          {photo?.readable_updated_at || '-'}
                        </Tag>
                      </p>
                      <Link to={`${photo?.id}`}>
                        <Button style={{ marginTop: 10 }} type='primary'>
                          Details
                        </Button>
                      </Link>
                    </div>
                  </Col>
                  <Col
                    xs={24}
                    md={6}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column'
                    }}
                  >
                    <p>Search photo: </p>
                    {photo?.search_photo ? (
                      <PhotoProvider>
                        <PhotoView src={photo?.search_photo}>
                          <img
                            style={{ maxWidth: 100, maxHeight: 100 }}
                            src={photo?.search_photo}
                            alt={photo?.id}
                          />
                        </PhotoView>
                      </PhotoProvider>
                    ) : (
                      '-'
                    )}
                  </Col>
                  <Col
                    xs={24}
                    md={6}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <div>
                      <p>Search text:</p>
                      <p>
                        <b>{photo?.search_text || '-'}</b>
                      </p>
                    </div>
                  </Col>
                </Row>
              </Card>
            ))
          : null}
      </div>
      {searchPagination ? (
        <Pagination
          defaultCurrent={1}
          current={searchPagination?.current_page}
          total={searchPagination?.total}
          pageSize={searchPagination?.per_page}
          onChange={(newPage) => onSearch(newPage)}
          showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
        />
      ) : null}
    </div>
  )
}
